import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import { PlusIcon } from "@/shared/icons";
import { appRouterPaths } from "@/services/navigation";
import { contactsActions } from "@/features/contacts/model";
import { useAppDispatch } from "@/services/store";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  type?: "float" | "classic";
};

export const AddContactButton: FC<Props> = ({ type = "classic" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const addHandler = () => {
    dispatch(contactsActions.setSelectedPersonId("TEMP_ID"));
    navigate(`${appRouterPaths.contacts.genInfo.replace(":personId", "TEMP_ID")}`);
  };
  return (
    <AppButton onClick={addHandler} type="primary" className={styles[type]}>
      {type === "classic" ? t("contactsPage.addContacts") : <PlusIcon className={styles.icon} />}
    </AppButton>
  );
};
